import * as S from '../EmbeddedLogin.styles'
import { translateManager as t } from '../../../services/TranslateManager'
import { useState } from 'react'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'
import { extractApiError } from '../../../utils/ApiUtils'
import { useAuth } from '../../../services/AuthProvider/AuthProvider'
import {
  setLastUsedLoginMethod,
  LOGIN_METHODS,
} from '../../../services/LoginUtills'

const MAX_EMAIL_LENGTH = 80

interface EmbeddedLoginFormProps {
  showError: (error: unknown) => void
  email: string
  setEmail: (value: string) => void
  setShowCode: (value: boolean) => void
  isLastUsed?: boolean
}

export function EmbeddedLoginForm({
  showError,
  email,
  setEmail,
  setShowCode,
  isLastUsed = false,
}: EmbeddedLoginFormProps) {
  const [isLoading, setIsLoading] = useState(false)
  const { initiateEmailSignIn } = useAuth()

  const handleEmailSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true)
    e.preventDefault()
    setLastUsedLoginMethod(LOGIN_METHODS.EMAIL)
    analytics.track(EVENT_NAMES.LOGIN_EMAIL_ENTERED, { Email: email })

    try {
      await initiateEmailSignIn(email)
      setShowCode(true)
    } catch (e) {
      const error = extractApiError(e) || e
      showError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleEmailChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setEmail(value.trim().toLowerCase())
  }

  return (
    <S.EmailForm onSubmit={handleEmailSubmit}>
      <S.LastUsedWrapper $isLastUsed={isLastUsed} $borderRadius={10}>
        {isLastUsed && (
          <S.LastUsedTag>{t.get('login.last_used')}</S.LastUsedTag>
        )}
        <S.LoginInput
          type="email"
          name="email"
          value={email}
          placeholder={t.get('login.email_capture_placeholder')}
          maxLength={MAX_EMAIL_LENGTH}
          required
          onChange={handleEmailChanged}
          data-testid="embedded-login-email-input"
        />
      </S.LastUsedWrapper>
      <S.Continue
        data-testid="embedded-login-email-submit-button"
        loading={isLoading}
        disabled={isLoading}
      >
        {t.get('new_email_capture.continue')}
      </S.Continue>
    </S.EmailForm>
  )
}
